export default "__VITE_ASSET__DBEAhJ21__"